import { render, staticRenderFns } from "./KelembagaanKabKota.vue?vue&type=template&id=5958c5eb"
import script from "./KelembagaanKabKota.vue?vue&type=script&lang=js"
export * from "./KelembagaanKabKota.vue?vue&type=script&lang=js"
import style0 from "./KelembagaanKabKota.vue?vue&type=style&index=0&id=5958c5eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports